import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CmsModalService} from '../../core/modal.service';
import {CmsNotifyService} from '../../core/notify.service';
import {CmsTranslateService} from '../../shared/translate.service';
import {validateJson} from '../../shared/json-editor/json-validator.directive';

@Component({
    selector: 'cms-add-menu-template-item',
    templateUrl: 'add-menu-template-item.component.html'
})

export class CmsAddMenuTemplateItemComponent implements OnInit {
    menuTemplateItem: FormGroup;
    titleValidationInterpolationParams;

    constructor(
        private modalService: CmsModalService,
        private fb: FormBuilder,
        private notifyService: CmsNotifyService,
        private translateService: CmsTranslateService
    ) {
        this.titleValidationInterpolationParams = {
            field: this.translateService.translate('common_title').toLowerCase(),
            maximum: '120'
        };
    }

    ngOnInit() {
        this.menuTemplateItem = this.fb.group({
            title: ['', [Validators.required, Validators.maxLength(120)]],
            subtitle: ['', []],
            description: ['', []],
            url: ['', []],
            icon: ['', []],
            active: [true, []],
            disabled: [false, []],
            customData: [{}, [validateJson]]
        });
    }

    addItem() {
        this.notifyService.notify({
            type: 'addItem',
            data: {
                fields: this.menuTemplateItem.value
            }
        });

        this.closePopup();
    }

    closePopup() {
        this.modalService.close('add-menu-template-item');
    }
}
